module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  " + _vm._s(_vm.word.words) + "\n  "), _c('audio', {
    ref: "player"
  }, [_c('source', {
    attrs: {
      "src": _vm.audioSrc,
      "type": "audio/mp3"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-485c9068","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EngGame/ewordBtn.vue
// module id = 449
// module chunks = 1 4